import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { Observable, catchError, throwError } from 'rxjs';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
/**
 * Endpoints where a 401 means "those credentials were wrong", not "your session
 * expired". Signing out and reloading on these would destroy the sign-in form the
 * user is currently typing into — and kick out any other session in this browser.
 */
const AUTH_ENTRY_POINT_URLS = [
    'api/users/login',
    'api/users/request-otp',
    'api/users/verify-otp',
];

const isAuthEntryPoint = (url: string): boolean =>
    AUTH_ENTRY_POINT_URLS.some((entryPoint) => url.includes(entryPoint));

export const authInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);
    let newReq = req.clone();

    if (
        authService.accessToken &&
        !AuthUtils.isTokenExpired(authService.accessToken)
    ) {
        newReq = req.clone({
            headers: req.headers.set(
                'Authorization',
                'Bearer ' + authService.accessToken
            ),
        });
    }

    return next(newReq).pipe(
        catchError((error) => {
            if (
                error instanceof HttpErrorResponse &&
                error.status === 401 &&
                !isAuthEntryPoint(req.url)
            ) {
                authService.signOut();

                // Reload the app for auth guard checks
                location.reload();
            }

            return throwError(error);
        })
    );
};